<template>
  <DxDataGrid
    :data-source="comenziData"
    key-expr="Id"
    show-borders
    :column-auto-width="false"
    :column-resizing-mode="'nextColumn'"
    :allow-column-reordering="true"
    :filter-row="{ visible: true }"
    :search-panel="{ visible: true, placeholder: 'Cauta...' }"
    :column-chooser="{ enabled: true, mode: 'select', allowSearch: true }"
    :paging="{ pageSize: 15 }"
    height="100%"
  >
    <DxExport :enabled="true" :formats="['pdf','xlsx']" :allow-export-selected-data="true" />

    <!-- Date Comandă -->
    <DxColumn caption="Date Comandă">
      <DxColumn data-field="Cod" caption="Cod" />
      <DxColumn data-field="Nume" caption="Client" />
      <DxColumn data-field="DataComenzii" caption="Data Comenzii" data-type="date" format="yyyy-MM-dd" />
      <DxColumn data-field="Tipcomanda" caption="Tip Comandă"/>
      <DxColumn data-field="ValoareComanda" caption="Valoare" data-type="number" format="#0.00"/>
      <DxColumn data-field="TotalComanda" caption="Total" data-type="number" format="#0.00"/>
      <DxColumn data-field="Motive" caption="Motive"/>
      <DxColumn data-field="Stare" caption="Stare"/>
    </DxColumn>

    <!-- Audit / Utilizatori -->
    <DxColumn caption="Audit / Utilizatori">
      <DxColumn data-field="UserCreare" caption="User Creare"/>
      <DxColumn data-field="DataCreare" caption="Data Creare" data-type="date" format="yyyy-MM-dd"/>
      <DxColumn data-field="UserModificare" caption="User Modificare"/>
      <DxColumn data-field="DataModificare" caption="Data Modificare" data-type="date" format="yyyy-MM-dd"/>
    </DxColumn>

    <!-- Contract / Documente -->
    <DxColumn caption="Contract / Documente">
      <DxColumn data-field="NumeContract" caption="Nume Contract"/>
      <DxColumn data-field="NumarContract" caption="Numar Contract"/>
      <DxColumn data-field="PathContract" caption="Path Contract"/>
      <DxColumn data-field="Observatii" caption="Observatii"/>
    </DxColumn>

    <!-- Expediere / Facturare -->
    <DxColumn caption="Expediere / Facturare">
      <DxColumn data-field="AgentId" caption="AgentID"/>
      <DxColumn data-field="FacturatorId" caption="FacturatorID"/>
      <DxColumn data-field="ExpeditieTipId" caption="Expeditie Tip"/>
      <DxColumn data-field="Tva" caption="TVA" data-type="number" format="#0.00"/>
      <DxColumn data-field="Discount" caption="Discount" data-type="number" format="#0.00"/>
      <DxColumn data-field="Facturat" caption="Facturat"/>
      <DxColumn data-field="FacturareZiDinLuna" caption="Zi Facturare"/>
    </DxColumn>

    <!-- Proiect / Valuta -->
    <DxColumn caption="Proiect / Valuta">
      <DxColumn data-field="ProiectId" caption="ProiectID"/>
      <DxColumn data-field="ValutaId" caption="ValutaID"/>
      <DxColumn data-field="ComandaSursaId" caption="Comanda Sursa ID"/>
      <DxColumn data-field="Curs" caption="Curs"/>
      <DxColumn data-field="PretValutaId" caption="Pret Valuta ID"/>
      <DxColumn data-field="PretCurs" caption="Pret Curs"/>
      <DxColumn data-field="PreturiCalculate" caption="Preturi Calculate"/>
    </DxColumn>

    <!-- Altele / Extra -->
    <DxColumn caption="Altele">
      <DxColumn data-field="PeStoc" caption="Pe Stoc"/>
      <DxColumn data-field="BonDeConfirmare" caption="Bon Confirmare"/>
      <DxColumn data-field="DelegatId" caption="DelegatID"/>
      <DxColumn data-field="PunctId" caption="PunctID"/>
      <DxColumn data-field="DataStartProductie" caption="Data Start Productie" data-type="date"/>
      <DxColumn data-field="TimpExecutie" caption="Timp Executie"/>
      <DxColumn data-field="Prioritate" caption="Prioritate"/>
      <DxColumn data-field="Explicatie" caption="Explicatie"/>
    </DxColumn>

    <!-- Buton Deschide Comanda -->
    <DxColumn type="buttons" width="150">
      <DxButton :onClick="onOpenOrder">
        <template #content>
          <span style="color:white; font-weight:bold;">Deschide Comanda</span>
        </template>
      </DxButton>
    </DxColumn>

  </DxDataGrid>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import DxDataGrid, { DxColumn, DxExport, DxButton } from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';

interface Filter { category: number | null; start: string; end: string; }
interface OrderData { [key:string]:any; }

const props = defineProps<{ filters: Filter }>();
const emit = defineEmits<{ (e:'openOrder', order: OrderData):void }>();

const comenziData = ref<OrderData[]>([]);

watch(() => props.filters, async (filters) => {
  const queryParams: string[] = [];
  if(filters.category!==null) queryParams.push(`Tipcomanda=${filters.category}`);
  if(filters.start) queryParams.push(`DataStart=${filters.start}`);
  if(filters.end) queryParams.push(`DataEnd=${filters.end}`);

  const url = AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi' + (queryParams.length ? `?${queryParams.join('&')}` : '');

  const store = new ODataStore({
    url,
    key:'Id',
    version:4,
    beforeSend:(e:any)=>{
      e.headers = {
        "Content-Type":"application/json",
        "Authorization":"Bearer "+localStorage.getItem("ERA_Jwt")
      };
    },
  });

  comenziData.value = await store.load();
}, { immediate:true });

function onOpenOrder(e: any){
  emit('openOrder', e.row.data);
}
</script>
